module.exports = {
  reqwest: require("reqwest")
};



//////////////////
// WEBPACK FOOTER
// ./~/mesosphere-shared-reactjs/utils/Reqwest.js
// module id = 779
// module chunks = 2